module.exports = __webpack_public_path__ + "img/artFont.d0755479.png";